





































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({ components: {} })
export default class PopUpGenerateReports extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: '' }) text!: string;

  handleCloseReport(): void {
    this.$emit('cerrar');
  }
}
